import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/axios";
import { toast } from "react-toastify";

export const fetchManages = createAsyncThunk(
  "manage/fetchManages",
  async () => {
    const response = await apiService.get("/question-paper/getAllPaper");
    return response.data?.filter((item)=>item?.isActive);
  }
);

export const addManage = createAsyncThunk(
  "manage/addmanage",
  async (manageData) => {
    const response = await apiService.post(
      "/question-paper/create",
      manageData
    );
    return response.data;
  }
);

export const toggleExamSwitch = createAsyncThunk(
  "exams/toggleSwitch",
  async (data) => {
    const response = await apiService.put(
      "/question-paper/updateQuestionPaper",
      {
        questionPaper_id: data?.id,
        isActive: data?.isActive,
      }
    );
    return response.updateManage;
  }
);

export const updateManage = createAsyncThunk(
  "manage/updateManage",
  async ({ questionPaper_id, updateData }) => {
    const response = await apiService.put(
      "/question-paper/updateQuestionPaper",
      {
        questionPaper_id,
        ...updateData,
      }
    );
    toast.success("Exam updated successfully");
    return response.data;
  }
);

export const deleteManage = createAsyncThunk(
  "manage/deleteManage",
  async ({ questionPaperId, isDelete }) => {
    const response = await apiService.put("/question-paper/delete", {
      questionPaperId,
      isDelete,
    });
    return { questionPaperId, ...response?.data };
  }
);

export const fetchExamAttempts = createAsyncThunk(
  "manage/fetchExamAttempts",
  async (id) => {
    try {
      const response = await apiService.get(`user/user-exam-attempts/${id}`);
      if (response?.data?.length === 0) {
        toast.error(response.message);
      }else{
        toast.success(response.message);
      }
      return response.data;
    } catch (err) {
      console.log("No data found")
    }
  }
);

const manageSlice = createSlice({
  name: "manage",
  initialState: {
    manages: [],
    loading: false,
    error: null,
    studentData: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchManages.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchManages.fulfilled, (state, action) => {
        state.loading = false;
        state.manages = action.payload;
      })
      .addCase(fetchManages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addManage.fulfilled, (state, action) => {
        state.manages.push(action.payload);
      })
      .addCase(updateManage.fulfilled, (state, action) => {
        const index = state.manages.findIndex(
          (cat) => cat._id === action.payload._id
        );
        if (index !== -1) {
          state.manages[index] = action.payload;
        }
      })
      .addCase(deleteManage.fulfilled, (state, action) => {
        state.manages = state.manages.filter(
          (cat) => cat._id !== action.payload
        );
      })
      .addCase(fetchExamAttempts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExamAttempts.fulfilled, (state, action) => {
        state.loading = false;
        state.studentData = action.payload;
      })
      .addCase(fetchExamAttempts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {} = manageSlice.actions;
export default manageSlice.reducer;
